<template>
  <div
    class="tw:flex tw:min-h-[200px] tw:flex-col tw:items-center tw:justify-center tw:gap-2 tw:text-center"
    :role="tone === 'danger' ? 'alert' : 'status'">
    <IconLoader2 v-if="tone === 'loading'" :size="32" class="tw:mb-2 tw:animate-spin tw:text-primary" />
    <IconCircleCheck v-else-if="tone === 'success'" :size="40" class="tw:mb-2 tw:text-success-700" />
    <IconAlertCircle v-else :size="40" class="tw:mb-2 tw:text-danger" />
    <h2 class="tw:m-0! tw:text-16! tw:font-semibold! tw:text-gray-900">{{ title }}</h2>
    <p v-if="text" class="tw:m-0! tw:text-14 tw:text-gray-600">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import { IconAlertCircle, IconCircleCheck, IconLoader2 } from '@tabler/icons-vue';

interface Props {
  tone: 'loading' | 'success' | 'danger';
  title: string;
  text?: string;
}

defineProps<Props>();
</script>
